module.exports = __webpack_public_path__ + "static/media/1Asset-28-100.95b6de54.jpg";